import React, { useState } from 'react';
import { IonButton, IonCol, IonGrid, IonList, IonPage, IonRow, IonText } from '@ionic/react';
import { ManageUserProfileAddContainer, ManageUserProfileEditContainer } from '../ManageUsersContainer';
import { Persona } from '../../components/persona/persona';
import { createStructuredSelector } from 'reselect';
import { getNetworkStatus, getUserMasterData } from '../../../selectors/selector';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../../pages/userProfile/userProfile.scss';
import { showNetworkAlert } from '../../../actions/App/action';
import { BUTTONS, CHANGE_PASSWORD_MESSAGE, CHANGE_PASSWORD_TITLE } from '../../../utils/constants';
import { useAuthService } from '../../../services/Auth';
import { Breadcrumb } from '../../../web/components/breadcrumb/Breadcrumb';
import saga from '../../../saga/Manage/saga';
import reducer from '../../../reducers/manage/reducer';
import useInjectSaga from '../../../utils/injectSaga';
import useInjectReducer from '../../../utils/injectReducer';
import { compose } from 'redux';
import { defaultForm } from '../../../web/pages/userProfile/userProfileUtil';
import { UserDeletionBtn } from '../../../web/pages/userProfile/UserDeletionBtn';
import { CustomModalWeb } from '../../../web/pages/userProfile/CustomModalWeb';

const key = 'manage';

const ManageProfileContainer: React.FC<any> = (props: any) => {
  const authService = useAuthService();
  const { userDetails, history } = props;
  const [initialSaveButtonState, setSaveButtonState] = useState<boolean>(false);
  const [initialFormFields, setFormFieldsState] = useState<any>({ ...defaultForm });
  const [onSave, setSave] = useState<number>(0);
  const [isAlertOpen, setShowAlert] = useState(false);
  const isEdit = history?.location?.state?.isEdit;
  const addMode: any = history?.location?.state?.addMode;
  const breadCrumb = [{ name: "Manage Users", backUrl: "/app/manage/ManageUser" }, { name: "View Profile", backUrl: '/app/userProfile' }, { name: "Edit Profile", backUrl: '' }];
  const breadCrumbAddUser = [{ name: "Manage Users", backUrl: "/app/manage/ManageUser" }, { name: "Add Driver/Dispatcher", backUrl: '' }];

  const selectedUserData = history?.location?.state?.selectedUser;
  const memberUserMasterData = userDetails?.memberDetailsResponse?.member
  const fullName = (selectedUserData) ?
    `${selectedUserData.firstName || ''} ${selectedUserData.lastName || ''}` :
    `${memberUserMasterData.firstName || ''} ${memberUserMasterData.lastName || ''}`;
  const isSelf = () => {
    if (selectedUserData && memberUserMasterData) {
      return memberUserMasterData?.upn  === selectedUserData?.upn
    }
    return false;
  }

  const validateForm = (formErrors: any, formFields: any, isSubmittable: boolean) => {
    if (initialFormFields === null) {
      setFormFieldsState({ ...formFields })
    }
    const { firstName: firstNameError, lastName, mobileNumber: mobileNumberError, tractorNumber } = formErrors;
    const { roles, mobileNumber, firstName } = formFields || {};
    if (!firstNameError && !lastName && !mobileNumberError && !tractorNumber && isSubmittable &&
      JSON.stringify(initialFormFields) !== JSON.stringify(formFields)) {
        if(roles?.length > 0 && mobileNumber?.length > 0 && firstName?.length > 0) {
          setSaveButtonState(isSubmittable)
        }
      return true;
    }
    setSaveButtonState(false)
    return false;
  }

  const onSuccess = () => {
    setFormFieldsState({ ...defaultForm });
  }

  const alertProps = {
    title: CHANGE_PASSWORD_TITLE,
    message_content: CHANGE_PASSWORD_MESSAGE,
    size: 'small_height',
    buttons: [
      {
        title: BUTTONS.CANCEL,
        type: "secondary-cta-btn-web",
        onClick: () => {
          setShowAlert(false);
        }
      },
      {
        title: BUTTONS.OK,
        type: "primary-cta-btn-web",
        onClick: () => {
          authService.changePassword();
          setShowAlert(false);
        }
      }
    ]
  };

  const isAddModeHandler = () => {
    if(addMode) {
      return <ManageUserProfileAddContainer {...props} onSave={onSave}
        validateForm={validateForm}
        authService={authService}
        selectedUser={null}
        addMode={addMode}
        submitable={initialSaveButtonState}
        isAssignDriver={props?.location?.state?.isAssignDriver}
        module={props?.location?.state?.module}
      />
    } else {
      return null;
    }
  }
  return <>
    <IonPage className="desktop-page myloads-page">
      <div className="my-profile-header">
        <Breadcrumb items={isEdit ? breadCrumb : breadCrumbAddUser} data={{
          title: "View Profile",
          selectedUser: selectedUserData
        }} />
        <h1 className="my-profile-title">{isEdit ? "Edit Profile" : "Add Driver/Dispatcher"}</h1>
      </div>
      <IonGrid className="profile-page-grid profile-page-web">
        {isEdit && <IonRow class="top-row">
          <IonCol class="name-col">
            <IonText>
              {fullName}
            </IonText>
          </IonCol>
        </IonRow>}
        <IonRow>
          <IonCol size="4">
            <IonRow class="user-profile-icon">
              <Persona
                viewProfile={true}
                name={fullName}
                showName={false}
              />
            </IonRow>

          </IonCol>
          <IonCol size="8">
            <IonList>
              {
                isEdit ? (
                  <ManageUserProfileEditContainer {...props}
                    validateForm={validateForm}
                    selectedUser={isSelf() ? memberUserMasterData : selectedUserData}
                    isEdit={isEdit} onSave={onSave}
                    authService={authService}
                    submitable={initialSaveButtonState}
                    onSuccess={onSuccess}
                  />
                ) : (isAddModeHandler())
              }
              {isSelf() ? (
                <div className="container-cta-btn">
                  <UserDeletionBtn />
                  <IonButton class="secondary-cta-btn-web extra-width"
                    onClick={() => {
                      if (props.isNetworkAvailable) setShowAlert(true);
                      else props.showNetworkAlert();
                    }}>
                    Change Password
                  </IonButton>
                </div>
              ) : null}
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
      <IonRow>
        <IonCol class="save-btn-col">
          <IonButton
            disabled={!initialSaveButtonState}
            className={(initialSaveButtonState) ? "save-btn" : "disabled-btn-save"}
            onClick={() => setSave(prev => prev + 1)}
          >
            Save
          </IonButton>
        </IonCol>
      </IonRow>
      <CustomModalWeb isModalOpen={isAlertOpen} {...alertProps} />
    </IonPage>
  </>
}
const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus()
});


export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });

export default compose(withSaga, withReducer, withConnect)(withRouter(ManageProfileContainer));
